import { Outlet, createFileRoute, redirect } from '@tanstack/react-router'
import { ensureMe } from '../lib/session.ts'
import { currentSite, signInUrl } from '../lib/site.ts'

/**
 * `<ProtectedRoute>` as a layout: everything beneath requires a session.
 * The org-scoped shell adds its own requirement on top (`_shell`); onboarding
 * lives here so a brand-new user with zero orgs can still get in.
 */
export const Route = createFileRoute('/_authed')({
  beforeLoad: async ({ context, location }) => {
    const me = await ensureMe(context.queryClient)
    if (!me) {
      // Hosted: id.forhim.io, which sends them back to this exact address.
      if (currentSite() !== null) throw redirect({ href: signInUrl(window.location.href) })
      throw redirect({ to: '/sign-in', search: { redirect: location.href } })
    }
    return { me }
  },
  component: () => <Outlet />,
})
